import { Player } from '@lottiefiles/react-lottie-player';
import appLoader from "@/asset/animation/appLoader.json";
import { Stack } from '@mui/material';

const Preloader = () => {
  return (
    <Stack width={"100%"} justifyContent={"center"} alignItems={"center"} height={"100vh"}>
      <Player
        autoplay
        loop
        src={appLoader}
        style={{ height: '200px', width: '200px' }}
      />
    </Stack>
  );
};

export default Preloader;
